// extracted by mini-css-extract-plugin
export default {"maincontainer":"my-project_maincontainer__Gw2tH","backgrond":"my-project_backgrond__fkGxe"};